function getYearFilterOptions() {
  const currentYear = new Date().getFullYear();

  return [
    { label: String(currentYear), value: "CURRENT_YEAR", header: "last_modified" },
    { label: String(currentYear - 1), value: "PAST_YEAR", header: "last_modified" },
  ];
}

export const FILTER_OPTIONS = [
  {
    label: "type_label",
    field: "resourceNodeType",
    data: [
      { label: "all_label", value: "ALL", header: "type_label" },
      { label: "resource_node_type_folder_label", value: "FOLDER", header: "type_label" },
      { label: "course_label", value: "FILE", header: "type_label" },
    ],
    selected: "ALL", // default value.
  },
  {
    label: "last_modified",
    field: "resourceNodeModifiedDateRange",
    data: [
      { label: "my_drive_filter_any_time_label", value: "ANY_TIME", header: "last_modified" },
      { label: "my_drive_filter_today_label", value: "TODAY", header: "last_modified" },
      { label: "my_drive_filter_past_week_label", value: "PAST_WEEK", header: "last_modified" },
      { label: "my_drive_filter_past_month_label", value: "PAST_MONTH", header: "last_modified" },
      ...getYearFilterOptions(),
    ],
    selected: "ANY_TIME", // default value.
  },
];

export const MY_DRIVE_TABS = {
  MY_DRIVE: "my-drive",
  SHARED_WITH_ME: "shared-with-me",
  TRASH: "trash",
};

import { reflectKeys } from "@utils/key.reflactor.ts";

export const NAMESPACE = {
  AUTH: "auth",
};

export const PACKAGE_TYPE = {
  LESSON: "NEW",
  COURSE: "COURSE",
};

export const LESSON_TYPE = {
  NEW: "NEW",
  COURSE: "COURSE",
  HTML5: "HTML5",
  URL: "URL",
};

export const COPY_ACTION_TYPE = reflectKeys([
  "COPY_NODE",
  "COPY_LESSON",
  "REATTEMPT_ASSIGNMENT_LESSON",
  "COPY_ASSIGNMENT_LESSON",
  "COPY_MOE_LESSON",
]);

export const RESOURCE_NODE_TYPE = reflectKeys(["FOLDER", "FILE"]);

export const TEMPLATE_TYPE = {
  LESSONS_AND_COURSES: "lessonsAndCourses",
  TEMPLATE: "template",
  TRASH: "trash",
};

export const MY_DRIVE_TAB = {
  LESSONS_AND_COURSES: "lessonsAndCourses",
  TEMPLATE: "template",
  TRASH: "trash",
};

export const SORT_DIRECTIONS = {
  DESC: "descending",
  ASC: "ascending",
};

export const SORT_FIELDS = {
  NAME: "name.raw",
  FILE_TYPE: "fileTypeSortingOrder",
  FILE_SUB_TYPE: "resourceNodeFileSubType",
  RESOURCE_NODE_FILE_METADATA_TYPE: "resourceNodeFileMetaData.type",
  LAST_MODIFIED_DATE: "nodeModifiedDate",
  OWNER_NAME: "resourceOwnerName",
  RESOURCE_NODE_TYPE: "resourceNodeType",
};

export const SEARCH_SOURCE_TYPE = reflectKeys([
  "SHARE",
  "LIBRARY",
  "TRASH",
  "SHARED_SEARCH",
  "MY_DRIVE_SEARCH",
  "TRASH_SEARCH",
]);

export const FROM_LOCATION_TYPE = {
  STUDENT_GROUP: "STUDENT_GROUP",
  MY_DRIVE: "MY_DRIVE",
  HOME: "HOME",
  ALP_TEMPLATE: "ALP_TEMPLATE",
  MOE_LIBRARY: "MOE_LIBRARY",
  COMMUNITY_GALLERY: "COMMUNITY_GALLERY",
  CALENDAR: "CALENDAR",
};
